var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlinkoX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,247.9c10.4-9.7,15.4-20.8,15.4-34c0-13.1-5.8-23.9-17-32.8c-11.2-8.9-25.5-13.5-42.5-13.5 s-30.9,4.6-42.5,13.5c-11.2,8.9-17,20.1-17,33.2s5,24.3,15.1,34c-14.3,10.8-21.2,25.1-21.2,42.8c0,15.1,6.2,27.8,18.1,37.8 c12,10.4,27.8,15.4,47.1,15.4s35.1-5,47.1-15.4c12-10.4,18.1-22.8,18.1-37.8C321.2,273.4,314.3,259.1,300,247.9L300,247.9z  M239.8,203.1c4.6-3.9,10-5.8,16.2-5.8c6.2,0,12,1.9,16.2,5.8c4.6,3.9,6.9,8.9,6.9,14.7s-2.3,10.8-6.9,14.7 c-4.6,3.9-10,5.8-16.2,5.8c-6.2,0-11.6-1.9-16.2-5.8c-4.6-3.9-6.9-8.9-6.9-14.7C232.8,212,235.2,207,239.8,203.1z M274.5,306.9 c-5.8,3.9-12,5.8-18.5,5.8c-6.6,0-12.7-1.9-18.5-5.8c-5.8-3.9-8.5-9.3-8.5-16.6c0-7.3,2.7-13.1,8.5-17c5.4-3.9,12-5.8,18.9-5.8 c6.9,0,13.1,1.9,18.9,5.8c5.4,3.9,8.5,9.7,8.5,17C283.8,297.7,280.3,303.1,274.5,306.9L274.5,306.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,12.8C121.7,12.8,12.8,121.7,12.8,256S121.7,499.2,256,499.2S499.2,390.3,499.2,256S390.3,12.8,256,12.8z  M256,409.6c-84.9,0-153.6-68.7-153.6-153.6S171.1,102.4,256,102.4S409.6,171.1,409.6,256S340.9,409.6,256,409.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlinkoX);
export default __webpack_public_path__ + "static/media/PlinkoX.6be6afe40098afab20edab53dbec5ae9.svg";
export { ForwardRef as ReactComponent };